import PropTypes from 'prop-types'
import { Button, Modal } from 'react-bootstrap'
import { formatearFecha } from '../../../helpers/dateValidation'
import { MAX_LENGTH_NOMBRE_LISTA } from './listaVentaFormUtils'

export const ListaVentaFormModal = ({
  show,
  title,
  values,
  errores,
  editMode = false,
  publicacionesPreview = [],
  cargandoPublicacionesPreview = false,
  onChange,
  onClose,
  onConfirm,
  confirmLabel = 'Guardar'
}) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group mb-3">
          <label htmlFor="listaVentaNombre">Nombre</label>
          <input
            id="listaVentaNombre"
            type="text"
            name="nombre"
            className="form-control"
            placeholder="Ingrese el nombre de la lista"
            value={values.nombre}
            onChange={onChange}
            maxLength={MAX_LENGTH_NOMBRE_LISTA}
          />
          {errores.nombre && <small className="text-danger">{errores.nombre}</small>}
        </div>

        <div className="form-group mb-3">
          <label htmlFor="listaVentaVigenciaDesde">Vigencia desde</label>
          <input
            id="listaVentaVigenciaDesde"
            type="date"
            name="vigenciaDesde"
            className="form-control"
            value={values.vigenciaDesde}
            onChange={onChange}
          />
          {errores.vigenciaDesde && <small className="text-danger">{errores.vigenciaDesde}</small>}
        </div>

        <div className="form-group mb-1">
          <label htmlFor="listaVentaVigenciaHasta">Vigencia hasta</label>
          <input
            id="listaVentaVigenciaHasta"
            type="date"
            name="vigenciaHasta"
            className="form-control"
            value={values.vigenciaHasta}
            onChange={onChange}
          />
          {errores.vigenciaHasta && <small className="text-danger">{errores.vigenciaHasta}</small>}
        </div>

        {editMode && (
          <div className="mt-3 p-3 border rounded-3 bg-body-tertiary">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="mb-0">Impacto en publicaciones de la lista</h6>
              {values.vigenciaHasta && (
                <span className="badge text-bg-primary">Nueva: {values.vigenciaHasta}</span>
              )}
            </div>
            <small className="text-muted d-block mb-3">
              Al guardar, estas publicaciones pasarán de su vigencia actual a la nueva vigencia
              seleccionada.
            </small>

            {cargandoPublicacionesPreview && (
              <div className="d-flex align-items-center gap-2 text-muted">
                <div
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></div>
                <span>Cargando publicaciones...</span>
              </div>
            )}

            {!cargandoPublicacionesPreview && publicacionesPreview.length === 0 && (
              <small className="text-muted">No se encontraron publicaciones para mostrar.</small>
            )}

            {!cargandoPublicacionesPreview && publicacionesPreview.length > 0 && (
              <div className="list-group list-group-flush">
                {publicacionesPreview.map((publicacion) => (
                  <div
                    key={publicacion.idPublicacion}
                    className="list-group-item px-0 d-flex justify-content-between align-items-center"
                  >
                    <span className="fw-semibold">{publicacion.titulo}</span>
                    <span className="text-muted">
                      {formatearFecha(publicacion.vigenciaHastaActual, 'YYYY-MM-DD') || '-'} -&gt;{' '}
                      {values.vigenciaHasta || '-'}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

ListaVentaFormModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  values: PropTypes.shape({
    nombre: PropTypes.string,
    vigenciaDesde: PropTypes.string,
    vigenciaHasta: PropTypes.string
  }).isRequired,
  errores: PropTypes.shape({
    nombre: PropTypes.string,
    vigenciaDesde: PropTypes.string,
    vigenciaHasta: PropTypes.string
  }),
  editMode: PropTypes.bool,
  publicacionesPreview: PropTypes.arrayOf(
    PropTypes.shape({
      idPublicacion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      titulo: PropTypes.string,
      vigenciaHastaActual: PropTypes.string
    })
  ),
  cargandoPublicacionesPreview: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmLabel: PropTypes.string
}

export default ListaVentaFormModal
